import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { BASE_URL } from '../../utils/BASE_URL';
import axios from 'axios';
import { toast } from 'react-hot-toast';

// const BASE_URL = "https://api.vallettagroup.in";

const initialState = {
    inquiries: [],
    loading: false,
    error: null,
    message: null
};

// Create Inquiry
export const createInquiry = createAsyncThunk(
    'inquiry/create',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BASE_URL}/inquiries`, data);
            toast.success('Your message has been sent successfully!');
            return response.data;
        } catch (error) {
            toast.error(error.response?.data?.message || 'Failed to send message');
            return rejectWithValue(error.response?.data);
        }
    }
);

// Get All Inquiries (Optional / For Admin likely)
export const getAllInquiries = createAsyncThunk(
    'inquiry/getAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BASE_URL}/inquiries`);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

// Update Inquiry Status
export const updateInquiryStatus = createAsyncThunk(
    'inquiry/updateStatus',
    async ({ id, status }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${BASE_URL}/inquiries/${id}`, { status });
            toast.success('Inquiry status updated successfully');
            return response.data;
        } catch (error) {
            toast.error(error.response?.data?.message || 'Failed to update status');
            return rejectWithValue(error.response?.data);
        }
    }
);

// Delete Inquiry
export const deleteInquiry = createAsyncThunk(
    'inquiry/delete',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axios.delete(`${BASE_URL}/inquiries/${id}`);
            toast.success('Inquiry deleted successfully');
            return id; // Return id to remove from state
        } catch (error) {
            toast.error(error.response?.data?.message || 'Failed to delete inquiry');
            return rejectWithValue(error.response?.data);
        }
    }
);

export const inquirySlice = createSlice({
    name: 'inquiry',
    initialState,
    reducers: {
        clearMessage: (state) => {
            state.message = null;
        },
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // Create
            .addCase(createInquiry.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createInquiry.fulfilled, (state, action) => {
                state.loading = false;
                state.message = action.payload.message;
            })
            .addCase(createInquiry.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message;
            })
            // Get All
            .addCase(getAllInquiries.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllInquiries.fulfilled, (state, action) => {
                state.loading = false;
                state.inquiries = action.payload;
            })
            .addCase(getAllInquiries.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message;
            })
            // Update Status
            .addCase(updateInquiryStatus.fulfilled, (state, action) => {
                const index = state.inquiries.findIndex(i => i._id === action.payload.inquiry._id);
                if (index !== -1) {
                    state.inquiries[index] = action.payload.inquiry;
                }
            })
            // Delete
            .addCase(deleteInquiry.fulfilled, (state, action) => {
                state.inquiries = state.inquiries.filter(i => i._id !== action.payload);
            });
    }
});

export const { clearMessage, clearError } = inquirySlice.actions;
export default inquirySlice.reducer;
